export enum CharacterDonationByWriterSortEnum {
  USER_ID = 'USER_ID',
  USERNAME = 'USERNAME',
  TOTAL_WRITING = 'TOTAL_WRITING',
  DONATION = 'DONATION',
}
